// In einer Hilfsdatei z. B. src/utils/localization.js
const getTextByLocale = (locale, deText, enText) => {
  return locale === "de" ? deText : enText;
};

export default getTextByLocale;
